<template id="main">
  <div>
    <v-img
      class="portrait-image"
      :aspect-ratio="16 / 9"
      :src="require('@/assets/orbit-simplicity-square.jpg')"
    ></v-img>
    <v-img
      class="landscape-image"
      :src="require('@/assets/orbit-simplicity-long-cropped.jpg')"
    ></v-img>
    <div class="outer">
      <div class="middle">
        <div class="inner">
          <v-alert type="error" v-model="showAlert" :dismissible="true">
            <span>{{ response }}</span>
          </v-alert>
          <v-form v-model="valid">
            <v-text-field
              v-model="credentials.username"
              :rules="[rules.required]"
              label="User ID"
              required
            ></v-text-field>
            <v-text-field
              v-model="credentials.userpass"
              :rules="[rules.required]"
              :type="'password'"
              name="input-10-2"
              label="Password"
              class="input-group--focused"
            ></v-text-field>

            <div style="display:flex;justify-content:space-around">
              <v-btn @click="login">Login</v-btn>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  mounted() {
    // window.screen.orientation.lock('portrait') //NOTE: SCREEN LOCK HERE
  },
  data() {
    return {
      valid: false,
      showAlert: false,
      response: "",
      credentials: {
        username: "ots",
        userpass: "OrbitMania9",
      },
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  methods: {
    login() {
      this.$root.setBusy("login", "Logging in . . .");
      this.$store
        .dispatch("auth/login", this.credentials)
        .then((resp) => {
          if (resp.loginSuccess === true) {
            console.log("AUTHENTICATED");
            this.$root.setBusy("refreshTables", "Refreshing tables . . .");
            this.refreshTables()
              .then((resp1) => {
                // console.log("FINISHING REFRESH:", resp1);
                // this.$router.push({ name: "CashBalances" });
                this.$router.push({ name: "CashPosition" });
              })
              .catch((err) => {
                console.log("Error refreshing tables:", err);
              })
              .finally(() => {
                this.$root.removeBusy("refreshTables");
              });
          } else {
            this.$dialog.error({
              text: "Please check credentials and server settings!",
              title: "Login Failed",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$dialog.error({
            text: err.errorMessage ?? err.message ?? "Unknown Error Occurred!",
            title: "Error",
          });
        })
        .finally(() => {
          this.$root.removeBusy("login");
        });
    },
    async refreshTables() {
      return this.$store.dispatch("localdb/refreshAllTables");
    },
  },
  computed: {
    current_user() {
      // return this.$store.state.user;
    },
  },
};
</script>

<style lang="css" scoped>
.login {
  width: 100%;
  text-align: center;
  background-color: blue;
  color: whitesmoke;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.clean {
  color: whitesmoke;
}

.outer {
  display: table;
  position: absolute;
  height: 60vh;
  width: 100%;
  text-align: center;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.inner {
  margin-left: auto;
  margin-right: auto;
  /*whatever width you want*/
  width: 60vw;
  display: block;
}

@media screen and (orientation: portrait) {
  .portrait-image {
    display: block;
  }

  .landscape-image {
    display: none !important;
  }
}

@media screen and (orientation: landscape) {
  .landscape-image {
    display: block;
    object-fit: contain;
    max-height: 44vh;
  }
  .portrait-image {
    display: none !important;
  }
}
</style>
